const getMultilevelSensorStateDescription = (sensorOperand, sensorValue, sensorScale) => {
  if (!sensorOperand || !sensorScale) {
    throw new Error('sensor unsupported')
  }
  return `${sensorOperand} ${sensorValue} ${sensorScale}`
}

export default getMultilevelSensorStateDescription
